// Local translations
export const T = {
  en_GB: {
    addUser: "Add User",
    cancel: "Cancel",
    save: "Save",
    disable: "Disable",
    usersCount: "Users",
    email: "Email",
    name: "Name",
    auth: "Auth",
    twoFa: "2FA",
    permissions: "Permissions",
    lastActive: "Last Active",
    actions: "Actions",
    sso: "SSO",
    password: "Password",
    enabled: "Enabled",
    searchPlaceholder: "Search users...",
    noUsersYet: "No users yet.",
    addUsersToGetStarted: "Add users to get started.",
    noSearchResults: "No users match your search.",
    deleteUser: "Delete User",
    deleteUserConfirmation: (email: string) =>
      `Delete "${email}"? They can no longer sign in and their sessions end. Their history stays and shows them as deleted. Creating a user with the same email later — or that person signing in with single sign-on — restores them.`,
    userRestored:
      "A previously deleted user with this email was restored, including their history.",
    cannotDeleteSelf: "You cannot delete your own user.",
    delete: "Delete",
    error: "Error",
    failedToDeleteUser: "Failed to delete user",
    ok: "OK",
    disableTwoFactor: "Disable Two-Factor Authentication",
    disableTwoFactorConfirmation: (email: string) =>
      `Are you sure you want to disable 2FA for "${email}"? They will need to set it up again if they want to use it.`,
    disable2FA: "Disable 2FA",
    failedToDisable2FA: "Failed to disable 2FA",
    editSsoUserPermissions: "Edit SSO User Permissions",
    editUser: "Edit User",
    addNewUser: "Add New User",
    editSsoUserDescription:
      "Edit permissions for this SSO user. Email, name, and password are managed by the identity provider.",
    editUserDescription: "Update the user information below.",
    addNewUserDescription: "Fill in the information to create a new user.",
    ssoUser: "SSO User",
    managedByIdp: "Managed by identity provider",
    emailRequired: "Email",
    emailPlaceholder: "user@example.com",
    nameLabel: "Name",
    namePlaceholder: "John Doe",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter password",
    leaveBlankToKeepPassword: "Leave blank to keep current password",
    leaveBlankPasswordPlaceholder: "Leave blank to keep current password",
    permissionsLabel: "Permissions",
    adminPermission: "Admin - Manage users",
    advisorPermission: "Advisor - Access to clients and flows",
    compliancePermission: "Compliance - Access compliance checks and audits",
    designerPermission: "Designer - Manage flows, risk models, portfolios, PDF templates",
    developerPermission: "Developer - Manage API keys and webhooks",
    permissionsHint: "Users must have at least one permission. Advisor is the default.",
    permissionsSsoHint:
      "Note: Permissions set here may be overwritten on next SSO login if the identity provider syncs roles.",
    somethingWentWrong: "Something went wrong",
    failedToSaveUser: "Failed to save user",
  },
  nb_NO: {
    addUser: "Legg til bruker",
    cancel: "Avbryt",
    save: "Lagre",
    disable: "Deaktiver",
    usersCount: "Brukere",
    email: "E-post",
    name: "Navn",
    auth: "Autentisering",
    twoFa: "2FA",
    permissions: "Tillatelser",
    lastActive: "Sist aktiv",
    actions: "Handlinger",
    sso: "SSO",
    password: "Passord",
    enabled: "Aktivert",
    searchPlaceholder: "Søk etter brukere...",
    noUsersYet: "Ingen brukere ennå.",
    addUsersToGetStarted: "Legg til brukere for å komme i gang.",
    noSearchResults: "Ingen brukere samsvarer med søket ditt.",
    deleteUser: "Slett bruker",
    deleteUserConfirmation: (email: string) =>
      `Slette «${email}»? Brukeren kan ikke lenger logge inn, og aktive økter avsluttes. Historikken beholdes og viser brukeren som slettet. Hvis du senere oppretter en bruker med samme e-post – eller personen logger inn med single sign-on – gjenopprettes brukeren.`,
    userRestored:
      "En tidligere slettet bruker med denne e-posten ble gjenopprettet, inkludert historikken.",
    cannotDeleteSelf: "Du kan ikke slette din egen bruker.",
    delete: "Slett",
    error: "Feil",
    failedToDeleteUser: "Kunne ikke slette bruker",
    ok: "OK",
    disableTwoFactor: "Deaktiver tofaktorautentisering",
    disableTwoFactorConfirmation: (email: string) =>
      `Er du sikker på at du vil deaktivere 2FA for "${email}"? De må sette det opp på nytt hvis de vil bruke det.`,
    disable2FA: "Deaktiver 2FA",
    failedToDisable2FA: "Kunne ikke deaktivere 2FA",
    editSsoUserPermissions: "Rediger SSO-brukertillatelser",
    editUser: "Rediger bruker",
    addNewUser: "Legg til ny bruker",
    editSsoUserDescription:
      "Rediger tillatelser for denne SSO-brukeren. E-post, navn og passord administreres av identitetsleverandøren.",
    editUserDescription: "Oppdater brukerinformasjonen nedenfor.",
    addNewUserDescription: "Fyll inn informasjonen for å opprette en ny bruker.",
    ssoUser: "SSO-bruker",
    managedByIdp: "Administreres av identitetsleverandør",
    emailRequired: "E-post",
    emailPlaceholder: "bruker@eksempel.com",
    nameLabel: "Navn",
    namePlaceholder: "Ola Nordmann",
    passwordLabel: "Passord",
    passwordPlaceholder: "Skriv inn passord",
    leaveBlankToKeepPassword: "La stå tom for å beholde nåværende passord",
    leaveBlankPasswordPlaceholder: "La stå tom for å beholde nåværende passord",
    permissionsLabel: "Tillatelser",
    adminPermission: "Administrator - Administrer brukere",
    advisorPermission: "Rådgiver - Tilgang til kunder og flyter",
    compliancePermission: "Compliance - Tilgang til samsvarskontroller og revisjoner",
    designerPermission: "Designer - Administrer flyter, risikomodeller, porteføljer, PDF-maler",
    developerPermission: "Utvikler - Administrer API-nøkler og webhooks",
    permissionsHint: "Brukere må ha minst én tillatelse. Rådgiver er standard.",
    permissionsSsoHint:
      "Merk: Tillatelser satt her kan bli overskrevet ved neste SSO-innlogging hvis identitetsleverandøren synkroniserer roller.",
    somethingWentWrong: "Noe gikk galt",
    failedToSaveUser: "Kunne ikke lagre bruker",
  },
} as const;
